import { StyleSheet } from 'react-native'
import { DS } from '../../design-system'
import { translate } from '../../i18n'

export const CreateGameTitle = () => {
  return (
    <DS.Frame style={styles.container}>
      <DS.Frame gap={'4'}>
        <DS.Text variant="Heading 1/Medium" color="Brand/Blue">
          {translate('createGameScreen.title')}
        </DS.Text>
        <DS.Text variant="Caption/Regular" color="Global/White">
          {translate('createGameScreen.subtitle')}
        </DS.Text>
      </DS.Frame>
      <DS.Icon name="Suite--Spade" size={48} color="Brand/Blue" />
    </DS.Frame>
  )
}

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
})
